import React, { useState } from "react";
import { Link } from "react-router-dom";
import Cookie from "js-cookie";
import { Col, Row, Space, Dropdown } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faUser, faArrowCircleRight, faStopwatch, faBars, faChalkboardTeacher } from "@fortawesome/free-solid-svg-icons";
import TimerModal from "../content/TimerModal";

function Header(props) {
  const [gearSpin, setGearSpin] = useState(false);
  const [stopwatchPulse, setStopwatchPulse] = useState(false);
  const [timerModalOpen, setTimerModalOpen] = useState(false);

  const SignOut = () => {
    Cookie.remove("x-access-token");
    props.MakeNotification("info", "Logged out! Redirecting...");
    setTimeout(() => {
      props.setAuthToken(null);
    }, 3000);
  };

  return (
    <nav className="navbar">
      <Row style={{ width: "100%" }}>
        <Col span={12}>
          <FontAwesomeIcon
            size="lg"
            icon={props.collapsed ? faBars : faBars}
            onClick={() => {
              props.setCollapsed(!props.collapsed);
            }}
            className="clickable"
            style={{ color: "white" }}
          />
        </Col>
        <Col span={12} className="text-right">
          <Space size={24} align="start">
            <FontAwesomeIcon
              size="lg"
              icon={faStopwatch}
              className={stopwatchPulse ? "fa-lg clickable fa-beat" : "fa-lg clickable"}
              style={{ color: "white" }}
              onClick={() => {
                setTimerModalOpen(true);
              }}
            />
            <Dropdown
              menu={{
                items: [
                  {
                    key: "1",
                    label: (
                      <Link to="/user-settings">
                        <FontAwesomeIcon icon={faUser} className="mx-2" />
                        My Profile
                      </Link>
                    ),
                  },
                  {
                    key: "100",
                    label: (
                      <Link
                        className="clickable"
                        onClick={() => {
                          props.setWelcomeTourOpen(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faChalkboardTeacher} className="mx-2" />
                        Quick Start Guide
                      </Link>
                    ),
                  },
                  {
                    key: "2",
                    type: "divider",
                  },
                  {
                    key: "3",
                    label: (
                      <Link className="clickable" onClick={SignOut}>
                        <FontAwesomeIcon icon={faArrowCircleRight} className="mx-2" />
                        Sign Out
                      </Link>
                    ),
                  },
                ],
              }}
              trigger={["click"]}
            >
              <FontAwesomeIcon
                icon={faCog}
                className="clickable"
                size="lg"
                style={{ color: "white" }}
                spin={gearSpin}
                onMouseEnter={() => {
                  setGearSpin(true);
                }}
                onMouseLeave={() => {
                  setGearSpin(false);
                }}
              />
            </Dropdown>
          </Space>
        </Col>
      </Row>

      <TimerModal {...props} open={timerModalOpen} setTimerModalOpen={setTimerModalOpen} setStopwatchPulse={setStopwatchPulse} />
    </nav>
  );
}

export default Header;
